import Color from 'color';
import {
  bgColor,
  mobileRes2, topBarColor
} from 'pages/styles';
import { lFColor0 } from '../theme';
import styled from 'styled-components';

export const orange = Color('#d6a615').darken(0).toString();

export const Container = styled.div`
  /* Grow when the list is short so the paginator stays at the panel bottom.
     Do not shrink below content — Hospitality is the vertical scroll, so the
     header/search/tokens move with the rooms instead of a nested list scroll. */
  flex: 1 0 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  /* visible: overflow-x hidden|auto forces overflow-y to auto (CSS pairing),
     which nested a second vertical scroller that often had nothing to move. */
  overflow: visible;
  z-index: 3;
  min-width: 0;
  width: 100%;
  max-width: 100%;
`;

export const RoomsCont = styled.div`
  flex: 1 0 auto;
  width: 100%;
  max-width: 100%;
  z-index: 1;
  /* Horizontal only. overflow-y: visible computes to auto when x is auto,
     and the x-scrollbar then leaves a tiny y-scroll that eats wheel ticks. */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const Room = styled.div<{ $elevated?: boolean }>`
  width: 100%;
  background: white;
  height: 60px;
  display: flex;
  /* 1050px minus the old rates column (115px); +50px reserve gap on wide screens */
  min-width: 935px;
  @media (min-width: 1121px) {
    min-width: 985px;
  }
  position: relative;
  overflow: visible;
  /* Open details panel must sit above later rows (each cell uses z-index: 1) */
  z-index: ${({ $elevated }) => ($elevated ? 40 : 'auto')};
`;

const newColor = Color(orange).lighten(0.995).toString();
const newColor2 = Color(newColor).darken(0.1).toString();
export const availableColor1 = Color(topBarColor).lighten(0.875).toString();
export const Recent = styled.div<{ isRecent: boolean, isHovered: boolean, isHighlight: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${Color('lightgrey').lighten(0.15).toString()};
  border-bottom: ${({ isRecent }) => isRecent && `1px solid ${newColor2}`};
  background: ${({ isRecent }) => isRecent && newColor};
  border-bottom: ${({ isHovered }) => isHovered && '1px solid lightgrey'};
  background: ${({ isHovered }) => isHovered && Color('lightgrey').lighten(0.1).toString()};
  border-bottom: ${({ isHighlight }) => isHighlight &&
    `1px solid ${Color(availableColor1).darken(0.05).toString()}`};
  background: ${({ isHighlight }) => isHighlight && availableColor1};
  z-index: 1;
`;

export const Area = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${Color('lightgrey').lighten(0.085).toString()};
  z-index: 1;
`;

export const NameArea = styled(Recent)`
  /* Fixed column so every row aligns; long names ellipsis inside RoomName */
  flex: 0 0 270px;
  width: 270px;
  min-width: 270px;
  max-width: 270px;
  padding-left: 17px;
  padding-right: 10px;
  overflow: hidden;
  position: sticky;
  left: 0;
  background: white;
  background: ${({ isRecent }) => isRecent && newColor};
  border-bottom: ${({ isHovered }) => isHovered && '1px solid lightgrey'};
  background: ${({ isHovered }) => isHovered && Color('lightgrey').lighten(0.1).toString()};
  border-bottom: ${({ isHighlight }) => isHighlight &&
    `1px solid ${Color(availableColor1).darken(0.05).toString()}`};
  background: ${({ isHighlight }) => isHighlight && availableColor1};
  z-index: 2;
  color: ${Color('#525252').darken(0.4).toString()};
  flex-direction: row;
  align-items: center;
  /* Sticky name column separator when the row scrolls horizontally */
  @media (max-width: 1120px) {
    border-right: 1px solid ${Color('lightgrey').lighten(0.15).toString()};
  }
  @media(max-width: ${mobileRes2}) {
    flex: 0 0 170px;
    width: 170px;
    min-width: 170px;
    max-width: 170px;
  }
`;

export const SelectCont = styled.div<{ isShow: boolean }>`
  height: 17px;
  width:  ${({ isShow }) => isShow ? '22px' : '0px'};
  overflow: hidden;
  flex-shrink: 0;
  /* Native checkboxes render a bit larger on small screens — keep icon clear of the box */
  @media (max-width: ${mobileRes2}) {
    width: ${({ isShow }) => isShow ? '18px' : '0px'};
  }
`;

export const SelectThis = styled.input`
  border-width: 3px;
  width: 17px;
  height: 17px;
  margin: 0;
  cursor: pointer;
`;

export const RoomNameIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  margin-left: 4px;
  border-radius: 8px;
  color: ${lFColor0};
  background: ${Color(lFColor0).alpha(0.1).toString()};
  @media (max-width: ${mobileRes2}) {
    margin-left: 6px;
  }
`;

export const RoomName = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-top: -3px;
  margin: auto 0 auto 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 5px;
  min-width: 0;
  flex: 1;
`;

export const FloorArea = styled(Recent)`
  /* Fixed width for housekeeping chip only */
  flex: 0 0 58px;
  width: 58px;
  min-width: 58px;
  max-width: 58px;
  padding: 4px 3px;
  justify-content: center;
  overflow: visible;
`;

/** Meal chip column — sits after Reserved/Available status */
export const MealArea = styled(Recent)`
  flex: 0 0 58px;
  width: 58px;
  min-width: 58px;
  max-width: 58px;
  padding: 7px 3px;
  justify-content: center;
  overflow: visible;
`;

export const HousekeepingCont = styled.div<{ isClean: boolean; isLoading: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex: 1 1 0;
  min-width: 48px;
  height: 100%;
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
  padding: 4px 2px;
  border-radius: 6px;
  transition: background 0.15s ease, transform 0.15s ease;
  opacity: ${({ isLoading }) => (isLoading ? 0.7 : 1)};
  
  &:hover {
    background: ${({ isClean, isLoading }) => (
    isLoading ? 'transparent'
      : isClean ? Color('#4CAF50').lighten(0.85).toString() : Color('#FF9800').lighten(0.85).toString()
  )};
    transform: ${({ isLoading }) => (isLoading ? 'none' : 'scale(1.04)')};
  }
`;

export const HousekeepingIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: -2px;
`;

export const HousekeepingText = styled.div<{ isClean: boolean }>`
  font-size: 9px;
  font-weight: 600;
  color: ${({ isClean }) => (isClean ? '#4CAF50' : '#FF9800')};
  text-align: center;
  line-height: 1.05;
  margin-top: 1px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Meal chip — idle (no meal to toggle) stays fully visible, muted. */
export const MealServiceCont = styled(HousekeepingCont)<{
  isClean: boolean;
  isLoading: boolean;
  $idle?: boolean;
}>`
  cursor: ${({ isLoading, $idle }) => (($idle || isLoading) ? 'default' : 'pointer')};
  background: ${({ $idle }) => ($idle ? '#f1f3f5' : 'transparent')};
  border: ${({ $idle }) => ($idle ? '1px dashed #ced4da' : '1px solid transparent')};
  opacity: ${({ isLoading }) => (isLoading ? 0.7 : 1)};
  &:hover {
    background: ${({ isClean, isLoading, $idle }) => {
    if ($idle || isLoading) return $idle ? '#f1f3f5' : 'transparent';
    return isClean
      ? Color('#4CAF50').lighten(0.85).toString()
      : Color('#FF9800').lighten(0.85).toString();
  }};
    transform: ${({ isLoading, $idle }) => (($idle || isLoading) ? 'none' : 'scale(1.04)')};
  }
`;

export const MealServiceText = styled(HousekeepingText)<{ isClean: boolean; $idle?: boolean }>`
  color: ${({ isClean, $idle }) => {
    if ($idle) return '#5c636a';
    return isClean ? '#4CAF50' : '#FF9800';
  }};
  font-weight: ${({ $idle }) => ($idle ? 600 : 700)};
`;

export const FloorCont0 = styled.div`
  transform: translateY(5px);
`;

export const FloorCont = styled.div`
  padding: 3px 10px;
  padding-bottom: 3px;
  border-radius: 4px;
  width: max-content;
  margin: auto;
  background: ${Color('#f0f0f0').darken(0.05).toString()};
  @media(max-width: ${mobileRes2}) {
    padding: 4px 10px;
    padding-bottom: 3px;
  }
`;

export const FloorNum = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: ${Color('#8f8f8f').darken(0.28).toString()};
  display: flex;
  align-items: flex-end;
`;

export const Suffix = styled.div`
  font-size: 11px;
  font-weight: 300;
`;

export const Floor = styled.div`
  font-size: 10px;
  font-weight: 400;
  color: ${Color('#ababab').darken(0.35).toString()};;
  text-align: center;
  padding-top: 1px;
  width: 100%;
  margin: auto;
  margin-left: auto;
  width: max-content;
`;

export const InfoArea = styled(Recent)`
  border-bottom: none;
  overflow: hidden;
  max-width: 350px;
  min-width: 210px;
  @media (min-width: 1240px) {
    flex: 0 0 calc(100vw - 985px);
    width: calc(100vw - 985px);
    min-width: calc(100vw - 985px);
    max-width: calc(100vw - 985px);
  }
`;

const StatusBlock = styled.div`
  flex: 1;
  margin: 8px;
  padding: 0 10px;
  border-radius: 8px;
  border: 1px solid transparent;
  align-items: center;
  justify-content: flex-start;
  display: flex;
  flex-direction: row;
  gap: 8px;
  min-width: 0;
  overflow: hidden;
`;

/** Icon tile — same footprint as the Reserve button icon */
export const StatusChipIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  flex-shrink: 0;
  svg {
    display: block;
  }
`;

export const StatusChipText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
  gap: 1px;
`;

export const StatusChipLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.15px;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StatusChipMeta = styled.div`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 1.2;
  opacity: 0.8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** Soft amber — booked, distinct from Available mint */
const reservedColor = Color(orange).lighten(0.72).toString();
const reservedInk = Color(orange).darken(0.42).toString();

export const Reserved = styled(StatusBlock)`
  background: ${reservedColor};
  color: ${reservedInk};
  border-color: ${Color(orange).lighten(0.45).toString()};
  cursor: pointer;
  transition: background 120ms ease;
  ${StatusChipIcon} {
    background: ${Color(orange).alpha(0.18).toString()};
    color: ${reservedInk};
  }
  &:hover {
    background: ${Color(orange).lighten(0.62).toString()};
  }
`;

const arrivingColor = Color(topBarColor).lighten(0.72).toString();
const arrivingInk = Color(topBarColor).darken(0.28).toString();

export const SoonCheckIn = styled(StatusBlock)`
  background: ${arrivingColor};
  border-color: ${Color(topBarColor).lighten(0.52).toString()};
  color: ${arrivingInk};
  cursor: pointer;
  transition: background 120ms ease;
  ${StatusChipIcon} {
    background: ${Color(topBarColor).alpha(0.16).toString()};
    color: ${arrivingInk};
  }
  &:hover {
    background: ${Color(topBarColor).lighten(0.62).toString()};
  }
`;

export const Cont1 = styled.div`
  display: flex;
`;

export const Countdown = styled(StatusChipLabel)`
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.5px;
  font-weight: 700;
  font-size: 13px;
`;

export const greenColor = '#56d651';
/** Soft mint fill — pairs with Reserved’s amber chip */
export const availableColor = Color(greenColor).lighten(0.48).toString();
const availableInk = Color(greenColor).darken(0.48).toString();

export const Available = styled(StatusBlock)`
  background: ${availableColor};
  color: ${availableInk};
  border-color: ${Color(greenColor).lighten(0.28).toString()};
  ${StatusChipIcon} {
    background: ${Color(greenColor).alpha(0.22).toString()};
    color: ${availableInk};
  }
`;

/** Soft slate — withdrawn from sellable inventory (not mint “Available”) */
export const OnHoldStatus = styled(StatusBlock)`
  background: #f1f3f5;
  color: #495057;
  border-color: #dee2e6;
  ${StatusChipIcon} {
    background: #e9ecef;
    color: #495057;
  }
`;

export const BookArea = styled(Recent)`
  flex: 0 0 auto;
  flex-direction: row;
  align-items: center;
  width: max-content;
  max-width: max-content;
  min-width: 0;
  /* Breathing room after Reserve; drop it when the row is already tight */
  padding-right: 50px;
  @media (max-width: 1120px) {
    padding-right: 0;
  }
`;

export const BookButtonIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  flex-shrink: 0;
  transition: background 140ms ease;
  svg {
    display: block;
  }
`;

export const BookButton = styled.button<{ $muted?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 32px;
  padding: 0 12px 0 5px;
  margin: auto 0 auto 8px;
  border-radius: 8px;
  font-family: inherit;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.15px;
  width: max-content;
  border: 1.5px solid ${({ $muted }) => (
    $muted ? '#e9ecef' : Color(lFColor0).alpha(0.28).toString()
  )};
  cursor: ${({ $muted }) => ($muted ? 'default' : 'pointer')};
  color: ${({ $muted }) => ($muted ? '#6c757d' : lFColor0)};
  background: ${({ $muted }) => (
    $muted ? '#f8f9fa' : Color(lFColor0).alpha(0.1).toString()
  )};
  transition: background 140ms ease, color 140ms ease, border-color 140ms ease,
    transform 80ms ease;

  ${BookButtonIcon} {
    background: ${({ $muted }) => (
    $muted ? '#e9ecef' : Color(lFColor0).alpha(0.14).toString()
  )};
    color: inherit;
  }

  &:hover {
    background: ${({ $muted }) => ($muted ? '#f8f9fa' : lFColor0)};
    color: ${({ $muted }) => ($muted ? '#6c757d' : '#fff')};
    border-color: ${({ $muted }) => ($muted ? '#e9ecef' : lFColor0)};
  }

  &:hover ${BookButtonIcon} {
    background: ${({ $muted }) => ($muted ? '#e9ecef' : 'rgba(255, 255, 255, 0.2)')};
  }

  &:active {
    transform: ${({ $muted }) => ($muted ? 'none' : 'scale(0.98)')};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px ${Color(lFColor0).alpha(0.22).toString()};
  }

  &:disabled {
    pointer-events: none;
  }
`;

export const PerksArea = styled(Recent)`
  max-width: 100%;
  min-width: 0;
  overflow: visible;
`;

export const PerksArea0 = styled(Area)`
  max-width: 100%;
  border-bottom: none;
  overflow: visible;
  margin: 0 13px 0 10px;
`;

export const PerksArea1 = styled(Area)<{ xPos: number }>`
  max-width: 100%;
  border-bottom: none;
  transform: ${({ xPos }) => `translateX(${xPos}px)`};
`;

export const PerksArea2 = styled(Area)`
  max-width: 100%;
  border-bottom: none;
  overflow: visible;
`;

export const PerkOptions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: auto 0px;
  min-width: 0;
`;

export const DetailsWrap = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const DetailsBtn = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 7px;
  border: 1.5px solid ${({ $active }) => (
    $active ? Color(lFColor0).alpha(0.35).toString() : '#e9ecef'
  )};
  background: ${({ $active }) => (
    $active ? Color(lFColor0).alpha(0.1).toString() : 'white'
  )};
  color: ${({ $active }) => ($active ? lFColor0 : '#6c757d')};
  cursor: pointer;
  font-family: inherit;
  transition: color 120ms ease, background 120ms ease, border-color 120ms ease;
  &:hover {
    color: ${lFColor0};
    border-color: ${Color(lFColor0).alpha(0.35).toString()};
    background: ${Color(lFColor0).alpha(0.06).toString()};
  }
`;

export const DetailsMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 220px;
  padding: 12px 14px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(33, 37, 41, 0.14);
  z-index: 1000;
  box-sizing: border-box;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-4px)')};
  transition: opacity 120ms ease, transform 120ms ease, visibility 120ms ease;
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  & + & {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f1f3f5;
  }
`;

export const DetailsKey = styled.div`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #868e96;
`;

export const DetailsVal = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
  line-height: 1.35;
  word-break: break-word;
`;

export const DetailsEmpty = styled.span`
  font-weight: 500;
  color: #868e96;
`;

export const ActionTags = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 0;
  cursor: pointer;
`;

export const ActionTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 13px;
  color: ${Color('#8c6200').darken(0.2).toString()};
  background: ${Color('#fff3cd').darken(0.02).toString()};
  padding: 2px 9px 1px 5px;
  font-size: 10.5px;
  font-weight: 500;
  min-width: 0;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    background: ${Color('#fff3cd').darken(0.08).toString()};
  }
`;

export const ActionTagMore = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 13px;
  color: ${Color('#8c6200').darken(0.25).toString()};
  background: ${Color('#fff3cd').darken(0.1).toString()};
  padding: 2px 7px 1px;
  margin-left: 4px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
  &:hover {
    background: ${Color('#fff3cd').darken(0.16).toString()};
  }
`;

export const ActionTagIcon = styled.div`
  color: ${Color('#8c6200').darken(0.2).toString()};
  display: flex;
  align-items: center;
  scale: 0.6;
  margin-right: -3px;
`;

export const ActionTagAdd = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 13px;
  color: #888;
  background: transparent;
  border: 1px dashed ${Color('#ccc').toString()};
  padding: 1px 9px 0 5px;
  font-size: 10.5px;
  font-weight: 500;
  min-width: max-content;
  cursor: pointer;
  &:hover {
    color: ${Color('#8c6200').darken(0.2).toString()};
    border-color: ${Color('#8c6200').lighten(0.4).toString()};
    background: ${Color('#fff3cd').lighten(0.05).toString()};
  }
`;

export const MenuArea = styled(Recent)`
  max-width: 30px;
  position: relative;
  z-index: auto;
  overflow: visible;
`;

export const MoreIcon = styled.div`
  margin: auto auto auto 5px;
  margin-right: auto;
  padding-right: 5px;
  color: #6c757d;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 10px;
  cursor: pointer;
  &:hover {
    color: ${orange};
  }
`;

export const NoRoomsCont = styled.div`
  /* Fill leftover space so pagination stays at the bottom even with no rows */
  flex: 1;
  min-height: 0;
  margin: 0 auto;
  width: max-content;
  max-width: 400px;
  background: transparent;
  padding: 60px 40px;
  padding-bottom: 40px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

export const EmptyIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: ${Color(bgColor).darken(0.03).toString()};
  color: ${Color('#525252').lighten(0.5).toString()};
  margin-bottom: 8px;
`;

export const NoRooms = styled.div`
  font-size: 22px;
  margin: 0;
  width: max-content;
  font-weight: 600;
  color: ${Color('#525252').darken(0.1).toString()};
`;

export const NoRoomsInfo = styled.div`
  font-size: 15px;
  color: ${Color('#525252').lighten(0.2).toString()};
  width: 100%;
  text-align: center;
  margin-top: 0;
  line-height: 1.4;
  max-width: 320px;
`;

export const NoRoomsInfo1 = styled.div`
  font-size: 13px;
  color: ${Color('#868e96').darken(0.15).toString()};
  width: 100%;
  text-align: center;
  margin-top: 0;
  font-weight: 500;
`;

export const ReloadPage = styled.div`
  color: ${Color('#525252').darken(0.1).toString()};
  font-size: 13px;
  text-decoration: underline;
  font-weight: 500;
  width: max-content;
  margin: auto;
  margin-top: 25px;
  cursor: pointer;
  &:hover {
    color: ${Color('#525252').darken(0.3).toString()};
  }
`;

export const PagesCont = styled.div`
  /* Always at the bottom of the rooms panel (not under short lists mid-page) */
  flex-shrink: 0;
  margin-top: auto;
  min-height: 48px;
  height: 48px;
  max-height: 48px;
  z-index: 2;
  border-top: 1px solid #e9ecef;
  background: white;
  /* Cap to panel width so horizontal room swipe never drags the paginator */
  width: 100%;
  max-width: 100%;
  min-width: 0;
`;

export const PagesCont1 = styled.div`
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: max-content;
  margin: auto;
`;

export const DropdownMenu = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 100%;
  right: 30px;
  background: white;
  border: 1px solid ${Color('#ccc').toString()};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 150px;
  z-index: 1000;
  overflow: hidden;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transform: ${({ isVisible }) => (isVisible ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.2s ease;
`;

export const DropdownMenuItem = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ disabled }) => (disabled ? '#ccc' : '#333')};
  font-size: 14px;
  gap: 8px;
  border-bottom: 1px solid ${Color('#f0f0f0').toString()};
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: ${({ disabled }) => (disabled ? 'transparent' : Color('#f8f9fa').toString())};
  }
`;

export const MenuIconWrapper = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  color: ${({ color }) => color || 'inherit'};
`;

export const MenuItemText = styled.span`
  flex: 1;
`;

export const MoreIconContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
`;
